export const AiAnimationVideoFileUrl = "https://cdn.shrpa.com/videos/misc/ai_loader.mp4";